import { ContactListPage } from '@/pages/crm/contacts/ContactListPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

const contactsSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(50),
	search: z.string().optional(),
	sortBy: z.enum(['name', 'createdAt']).default('createdAt'),
	sortDirection: z.enum(['asc', 'desc']).default('desc'),
	// "Created" range, ISO instants so a filtered list is shareable.
	createdFrom: z.string().optional(),
	createdTo: z.string().optional(),
	duplicates: z.coerce.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/crm/contacts/')({
	beforeLoad: ({ context }) => requireAnyPermission({ context, anyOf: ['contacts.read'], redirectTo: '/dashboard' }),
	component: ContactListPage,
	validateSearch: contactsSearchSchema,
});
